export default "__VITE_ASSET__D16EW4ao__"